import React, { useRef, useState } from "react";
import { Button } from "../../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "../../../../design/dialog";
import {
  multiFactor,
  PhoneAuthProvider,
  PhoneMultiFactorGenerator,
  RecaptchaVerifier,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { useAuth } from "../../../../contexts/AuthContext";
import { auth } from "../../../../firebase";
import { Heading, Subheading } from "../../../../design/heading";
import { Input } from "../../../../design/input";
import { Field, FieldGroup, Label } from "../../../../design/fieldset";
import PhoneNumberInput from "../../../../components/PhoneNumberInput";

const State = {
  Enroll: "enroll",
  Password: "password",
  Code: "code",
};

const SecurityInformation = ({}) => {
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [state, setState] = useState<"enroll" | "password" | "code">("enroll");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [verificationId, setVerificationId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const captchaRef = useRef(null);

  const onSubmit = async () => {
    if (!user) return;
    setError(null);
    setLoading(true);

    try {
      switch (state) {
        case "password":
          const email = user.email;
          await signInWithEmailAndPassword(auth, email!, password);
          setState("enroll");
          break;
        case "enroll":
          const session = await multiFactor(user).getSession();
          const phoneInfoOptions = {
            phoneNumber: phoneNumber.replace(/[^\d+]/g, ""),
            session,
          };
          const phoneAuthProvider = new PhoneAuthProvider(auth);

          const recaptchaVerifier = new RecaptchaVerifier(
            auth,
            captchaRef.current!,
            {
              size: "normal",
              callback: (c: any) => {
                console.log("recaptchaVerifier callback");
              },
            },
          );

          const verificationId = await phoneAuthProvider.verifyPhoneNumber(
            phoneInfoOptions,
            recaptchaVerifier,
          );
          console.log("verificationId", verificationId);
          setVerificationId(verificationId);
          setState("code");
          break;
        case "code":
          const credential = PhoneAuthProvider.credential(
            verificationId!,
            code,
          );
          const multiFactorAssertion =
            PhoneMultiFactorGenerator.assertion(credential);
          await multiFactor(user).enroll(
            multiFactorAssertion,
            "My personal phone number",
          );
          setModalOpen(false);
          break;
      }
    } catch (e: any) {
      switch (e.code) {
        case "auth/requires-recent-login":
          setState("password");
          break;
        default:
          setError(e);
          break;
      }
    }

    setLoading(false);
  };

  const renderBody = () => {
    switch (state) {
      case "code":
        return (
          <>
            <Heading>Please enter the code we just sent via SMS</Heading>
            <FieldGroup>
              <Field>
                <Label htmlFor="email">Email</Label>
                <Input
                  key={"code"}
                  placeholder={"Code"}
                  autoComplete={"off"}
                  onChange={(e) => setCode(e.target.value)}
                />
              </Field>
            </FieldGroup>
          </>
        );
      case "password":
        return (
          <>
            <Heading>Please verify password</Heading>
            <FieldGroup>
              <Field>
                <Label htmlFor="email">Email</Label>
                <Input
                  key={"password"}
                  placeholder={"Password"}
                  autoComplete={"off"}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Field>
            </FieldGroup>
          </>
        );
      case "enroll":
        return (
          <>
            <Heading>Please enter your phone number</Heading>
            <Subheading>
              We will send you a code via SMS to verify your phone number
            </Subheading>
            <FieldGroup>
              <Field>
                <Label htmlFor="email">Email</Label>
                <PhoneNumberInput
                  key={"phone"}
                  placeholder={"Phone Number"}
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e)}
                />
              </Field>
            </FieldGroup>
          </>
        );
    }
  };

  return (
    <>
      <Button onClick={() => setModalOpen(true)}>Cool</Button>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        //   trigger={
        //     <Button
        //       floated={"right"}
        //       icon={"plus"}
        //       content={"Add step"}
        //       onClick={() => setModalOpen(true)}
        //     />
        //   }
      >
        <DialogTitle>Add Two Factor Authentication: SMS</DialogTitle>
        <DialogBody>{renderBody()}</DialogBody>
        <DialogBody>
          <div id="recaptcha-container" ref={captchaRef} />
        </DialogBody>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)}>Cancel</Button>
          <Button onClick={onSubmit} disabled={loading}>
            {loading ? "Loading..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SecurityInformation;
